export const detailNotes = [
  {
    no: "01",
    title: "被忽略的发布顺序",
    summary:
      "两段声明前后只差 40 分钟，但先后顺序直接决定了谁是'回应方'、谁掌握主动权。",
    attention: "高",
  },
  {
    no: "02",
    title: "同一个词，两个意思",
    summary:
      "争议双方都在用'临时'这个词，但一方指的是排期调整，另一方理解为责任推脱。",
    attention: "高",
  },
  {
    no: "03",
    title: "被删掉的那条转发",
    summary:
      "截图时间戳显示，删除发生在质疑出现之后，而非当事人所说的事前清理。",
    attention: "中",
  },
  {
    no: "04",
    title: "数据口径的悄悄变化",
    summary:
      "两次公开的统计包含了不同范围，口径一变，结论就从'增长'变成了'持平'。",
    attention: "中",
  },
  {
    no: "05",
    title: "沉默的 17 分钟",
    summary:
      "在关键节点上，当事人的账号出现了明显的暂停痕迹，这段时间发生了什么值得追问。",
    attention: "高",
  },
  {
    no: "06",
    title: "被当成证据的表情包",
    summary:
      "一张被反复引用的截图其实是二创，但它已经进入了无数人的'记忆'里。",
    attention: "低",
  },
];

export const detailImage =
  "https://readdy.ai/api/search-image?query=abstract%20detail%20of%20a%20notebook%20filled%20with%20hand%20drawn%20diagrams%20and%20arrows%20on%20a%20warm%20cream%20desk%2C%20amber%20task%20light%2C%20charcoal%20shadows%2C%20simple%20uncluttered%20background%2C%20artistic%20editorial%20photography%2C%20no%20text&width=800&height=1000&seq=hlkd-detail-01&orientation=portrait";